<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="8" style="text-align: left">
          <!-- <v-btn text x-small v-for="i in listStatus" :key="i"> -->
          <v-btn
            text
            x-small
            @click="
              status = '';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="info"
                :content="totalOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == ''" style="color: #7cb342">All</b>
                <b v-else>All</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Pending';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="pendingOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Pending'" style="color: #7cb342">Pending</b>
                <b v-else>Pending</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Missing Design';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="missingDesignOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Missing Design'" style="color: #7cb342"
                  >Missing Design</b
                >
                <b v-else>Missing Design</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Processing';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="processingOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Processing'" style="color: #7cb342"
                  >Processing</b
                >
                <b v-else>Processing</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'On Hold';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="onHoldOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'On Hold'" style="color: #7cb342">On Hold</b>
                <b v-else>On Hold</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'In Production';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="blue darken-3"
                :content="inProductionOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'In Production'" style="color: #7cb342"
                  >In Production</b
                >
                <b v-else>In Production</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'In Transit';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="blue darken-3"
                :content="inTransitOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'In Transit'" style="color: #7cb342"
                  >In Transit</b
                >
                <b v-else>In Transit</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Delivered';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="blue darken-3"
                :content="deliveredOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Delivered'" style="color: #7cb342"
                  >Delivered</b
                >
                <b v-else>Delivered</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Need Resend';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="red"
                :content="needResendOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Need Resend'" style="color: #7cb342"
                  >Need Resend</b
                >
                <b v-else>Need Resend</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Partially Refunded';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="red"
                :content="partiallyRefundedOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Partially Refunded'" style="color: #7cb342"
                  >Partially Refunded</b
                >
                <b v-else>Partially Refunded</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Refunded';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="red"
                :content="refundedOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Refunded'" style="color: #7cb342"
                  >Refunded</b
                >
                <b v-else>Refunded</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Completed';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="success"
                :content="completedOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Completed'" style="color: #7cb342"
                  >Completed</b
                >
                <b v-else>Completed</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              status = 'Canceled';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="purple"
                :content="canceledOrders.toString()"
                style="font-size: 10px"
              >
                <b v-if="status == 'Canceled'" style="color: #7cb342"
                  >Canceled</b
                >
                <b v-else>Canceled</b>
              </v-badge>
            </v-tab>
          </v-btn>
        </v-col>

        <v-col cols="4" style="text-align: right">
          <v-btn small @click.stop="drawer = !drawer" outlined color="indigo"
            >Filter Data</v-btn
          >
          &nbsp;
          <template>
            <v-speed-dial
              v-model="fab"
              :direction="direction"
              :open-on-hover="hover"
              :transition="transition"
              style="width: 15px; display: inline"
              v-if="
                dialogFulfill == false &&
                dialogStatus == false &&
                dialogOrder == false &&
                dialogTracking == false &&
                dialogPreProcess == false &&
                dialogCreateAmz == false &&
                dialogEditAmz == false
              "
            >
              <template v-slot:activator>
                <v-btn small v-model="fab" color="blue darken-2" dark>
                  More Actions
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <template>
                <v-btn
                  small
                  color="success"
                  @click="dialogCreateAmz = !dialogCreateAmz"
                  >Add Amazon Order<v-icon right dark
                    >mdi-plus-thick</v-icon
                  ></v-btn
                >
              </template>
              <template v-if="status != 'Pending'">
                <v-btn
                  small
                  color="teal"
                  class="white--text"
                  @click="dialogPreProcess = !dialogPreProcess"
                  v-if="roles.preprocess_order"
                >
                  Preprocess Order
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
                <v-btn small color="teal" class="white--text" v-else disabled>
                  Preprocess Order
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
              </template>
              <template>
                <v-btn
                  small
                  color="blue-grey"
                  class="white--text"
                  @click="dialogOrder = !dialogOrder"
                  v-if="roles.import_order"
                >
                  Import Order
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="blue-grey"
                  class="white--text"
                  v-else
                  disabled
                >
                  Import Order
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
              </template>
              <v-btn
                small
                color="deep-purple darken-4"
                class="white--text"
                @click="dialogStatus = !dialogStatus"
                v-if="roles.change_order_status"
                >Change Status ({{ selected.length }})</v-btn
              >
              <v-btn
                small
                color="deep-purple darken-4"
                class="white--text"
                v-else
                disabled
                >Change Status ({{ selected.length }})</v-btn
              >
              <template v-if="status != 'Pending'">
                <v-btn
                  small
                  color="orange"
                  class="white--text"
                  @click="dialogTracking = !dialogTracking"
                  v-if="roles.import_tracking"
                >
                  Import Tracking
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
                <v-btn small color="orange" class="white--text" v-else disabled>
                  Import Tracking
                  <v-icon right dark>mdi-calendar-import</v-icon>
                </v-btn>
              </template>
              <template>
                <v-btn
                  small
                  color="brown darken-1"
                  class="white--text"
                  @click="exportMissingTrack"
                  v-if="roles.export_order_missing_tracking"
                >
                  Export Missing Track
                  <v-icon right dark>mdi-calendar-export</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="brown darken-1"
                  class="white--text"
                  v-else
                  disabled
                >
                  Export Missing Track
                  <v-icon right dark>mdi-calendar-export</v-icon>
                </v-btn>
              </template>
              <template>
                <v-btn
                  small
                  color="blue darken-1"
                  class="white--text"
                  @click="exportSelectedOrders"
                  v-if="selected.length > 0 && roles.ez_export"
                  >EZ Export ({{ selected.length }})</v-btn
                >
                <v-btn
                  small
                  color="blue darken-1"
                  class="white--text"
                  v-else
                  disabled
                  >EZ Export</v-btn
                >
              </template>
            </v-speed-dial>

            <!-- <v-speed-dial
              v-model="fab"
              :direction="direction"
              :open-on-hover="hover"
              :transition="transition"
              style="width: 15px; display: inline"
              v-else
            >
              <template v-slot:activator>
                <v-btn small v-model="fab" color="blue darken-2" dark disabled>
                  More Actions
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-menu-down</v-icon>
                </v-btn>
              </template>
            </v-speed-dial> -->
            &nbsp;

            <template v-if="selected.length > 0">
              <!-- {{selected.length}} item(s) selected &nbsp; -->
              <v-btn
                small
                color="blue-grey darken-3"
                class="white--text"
                @click="clearSelected"
                >Clear ({{ selected.length }})<v-icon right dark
                  >mdi-eraser</v-icon
                ></v-btn
              >
            </template>
            &nbsp;

            <template>
              <v-btn
                small
                color="info"
                class="white--text"
                @click="dialogFulfill = !dialogFulfill"
                v-if="status == 'Processing' && roles.fulfill_order"
                >Fulfill<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
              <v-btn small color="info" class="white--text" v-else disabled
                >Fulfill<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
            </template>
            &nbsp;
            <template>
              <v-btn
                small
                color="info"
                class="white--text"
                @click="exportPendingOrders"
                v-if="status == 'Pending' && roles.export_pending_order"
                >Export<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
              <v-btn small color="info" class="white--text" v-else disabled
                >Export<v-icon right dark>mdi-calendar-export</v-icon></v-btn
              >
            </template>
            &nbsp;
            <router-link
              to="/order-preview"
              style="text-decoration: none"
              v-if="roles.preview_customily"
            >
              <v-btn small color="light-green" class="white--text"
                >Preview<v-icon right dark>mdi-eye</v-icon></v-btn
              >
            </router-link>
            <v-btn small color="light-green" class="white--text" v-else disabled
              >Preview<v-icon right dark>mdi-eye</v-icon></v-btn
            >
          </template>

          <!-- <v-btn small color="info" class="white--text" @click="dialogFulfill = !dialogFulfill" >Fulfill<v-icon right dark>mdi-calendar-export</v-icon></v-btn>          -->
          <!-- &nbsp;<v-btn small  class="btn btn-primary btn-sm" @click="check"><i class="fa fa-plus-square"></i> Check</v-btn>&nbsp; -->
          <!-- <ImportOrder/>
          <ImportTracking/> -->
        </v-col>
      </v-row>
    </v-col>

    <v-alert
      v-model="alertSuccess"
      close-text="Close Alert"
      dense
      text
      type="success"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <v-alert
      v-model="alertError"
      close-text="Close Alert"
      dense
      text
      type="error"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <!-- <v-col cols="12" v-if="dialogFulfill == false && dialogStatus == false" style="margin-top:0px"> -->
    <v-col cols="12" style="margin-top: -15px">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="orders"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        item-key="order_id"
        show-select
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, 200, 500, 800, 1000],
        }"
      >
        <template v-slot:item.order_number="{ item }">
          <td>
            <!-- <template v-if="!item.urgent"> -->
            <div>{{ item.order_number }}</div>
            <div>
              <template v-if="item.amazon_info">{{ item.store_code }}</template>
              <template v-else>{{ item.order_id }}</template>
            </div>
            <!-- </template>
            <template v-else>
              <span style="color: red">
                <div>{{ item.order_number }}</div>
                <div>{{ item.order_id }}</div>
              </span>
            </template> -->
          </td>
        </template>
        <template v-slot:item.order_time="{ item }">
          <!-- <div v-if="!item.urgent"> -->
          <div>
            <b>{{ item.createdFromNow }}</b>
          </div>
          {{ item.order_time }}
          <!-- </div>
          <div v-else style="color: red">
            <div>
              <b>{{ item.createdFromNow }}</b>
            </div>
            {{ item.order_time }}
          </div> -->
        </template>
        <template v-slot:item.customer_info="{ item }">
          <td>
            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  {{ item.customer_info.first_name }}
                  {{ item.customer_info.last_name }}
                </a>
              </template>
              <v-card class="mx-auto" max-width="344" outlined>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="headline mb-1"
                      >{{ item.customer_info.first_name }}
                      {{ item.customer_info.last_name }}</v-list-item-title
                    >
                    <div class="overline mb-4">
                      {{ item.customer_info.phone }}
                    </div>
                    <v-list-item-subtitle>{{
                      item.customer_info.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="item.showName = false"
                    >More Info +</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>
        </template>
        <template v-slot:item.payment_info.total="{ item }">
          <!-- <template v-if="!item.urgent"> -->
          <td>$ {{ item.payment_info.total }}</td>
          <!-- </template>
          <template v-else>
            <td style="color: red">$ {{ item.payment_info.total }}</td>
          </template> -->
        </template>
        <template v-slot:item.latest_ship_date="{ item }">
          <td>
            <template v-if="item.amazon_info">
              <template v-if="!item.urgent">
                <div>
                  <b>{{ item.lastestShipFromNow }}</b>
                </div>
                {{ item.amazon_info.latest_ship_date }}
              </template>
              <template v-else>
                <span style="color: red">
                  <div>
                    <b>{{ item.lastestShipFromNow }}</b>
                  </div>
                  {{ item.amazon_info.latest_ship_date }}
                </span>
              </template>
            </template>
          </td>
        </template>
        <template v-slot:item.financial_status="{ item }">
          <td>
            {{ item.payment_info.financial_status }}
          </td>
        </template>
        <template v-slot:item.current_status="{ item }">
          <td>
            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  {{ item.current_status }}
                </a>
              </template>
              <v-card class="mx-auto status-scroll" max-width="344" outlined>
                <v-col
                  cols="12"
                  three-line
                  v-for="(i, index) in item.order_statuses.slice().reverse()"
                  :key="index"
                  class="border"
                  style="text-align: left; font-size: 12px"
                >
                  <!-- <template v-if="index == item.order_statuses.length-1"> -->
                  <template v-if="index == 0">
                    <b style="color: green">Current Status</b>
                    <!-- {{item.current_status}} -->
                    <div style="color: green">
                      <b>Status:</b> {{ i.status }}
                    </div>
                    <div style="color: green">
                      <b>Updated Date:</b> {{ i.updated_date }}
                    </div>
                    <div style="color: green">
                      <b>Updated User:</b> {{ i.updated_user }}
                    </div>
                    <div style="color: green">
                      <b>Short Description:</b> {{ i.short_description }}
                    </div>
                    <div style="color: green">
                      <b>Detail Description:</b> {{ i.detail_description }}
                    </div>
                  </template>
                  <template v-else>
                    <div><b>Status:</b> {{ i.status }}</div>
                    <div><b>Updated Date:</b> {{ i.updated_date }}</div>
                    <div><b>Updated User:</b> {{ i.updated_user }}</div>
                    <div>
                      <b>Short Description:</b> {{ i.short_description }}
                    </div>
                    <div>
                      <b>Detail Description:</b> {{ i.detail_description }}
                    </div>
                  </template>
                </v-col>
              </v-card>
            </v-menu>
          </td>
        </template>
        <template v-slot:item.items="{ item }">
          <td>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on" style="text-decoration:none;color:black;">{{item.items.length}} item(s)</a>
              </template>
              <v-card
                class="mx-auto"
                max-width="344"
                outlined
              >
                <v-list-item three-line v-for="(i,index) in item.items" :key="index">
                  <v-list-item-content style="text-align:left">
                    <v-list-item-subtitle><b>Name:</b> {{i.item_name}}</v-list-item-subtitle>
                    <v-list-item-subtitle><b>SKU:</b> {{i.sku}}</v-list-item-subtitle>
                    <v-list-item-subtitle><b>Quantity:</b> {{i.quantity}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-tooltip> -->
            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <template v-if="!item.missingSKU">
                  <a v-bind="attrs" v-on="on">
                    {{ item.items.length }} item(s)
                  </a>
                </template>
                <template v-else
                  ><a v-bind="attrs" v-on="on">
                    <v-chip color="orange" dark>
                      {{ item.items.length }} item(s)
                    </v-chip>
                  </a></template
                >
              </template>
              <v-card class="mx-auto" max-width="344" outlined>
                <v-list-item
                  three-line
                  v-for="(i, index) in item.items"
                  :key="index"
                  class="border"
                >
                  <v-list-item-content style="text-align: left">
                    <div><b>Name:</b> {{ i.item_name }}</div>
                    <div><b>SKU:</b> {{ i.sku }}</div>
                    <div><b>Quantity:</b> {{ i.quantity }}</div>
                    <div>
                      <b>Design URL:</b>
                      <a
                        :href="i.design_url"
                        target="_blank"
                        v-if="i.design_url"
                        >Link</a
                      >
                    </div>
                    <!-- <v-list-item-subtitle><b>Customer Choice:</b> {{i.customer_choice}}</v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-menu>
          </td>
        </template>
        <template v-slot:item.priority="{ item }">
          <td>
            <template v-if="item.priority == 0">
              <v-chip class="ma-2"> Normal </v-chip>
            </template>
            <template v-else-if="item.priority == 1">
              <v-chip class="ma-2" color="orange" dark> High </v-chip>
            </template>
            <template v-else>
              <v-chip class="ma-2" color="red" dark> Urgent </v-chip>
            </template>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            x-small
            @click="editItem(item.order_id)"
            v-if="item.current_status != 'Pending' && roles.read_order"
          >
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn
            color="primary"
            x-small
            @click="
              orderSelected = item;
              dialogEditAmz = !dialogEditAmz;
            "
            v-else-if="
              item.current_status == 'Pending' &&
              roles.read_order &&
              item.order_number.indexOf('-') > 0
            "
          >
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>

          <v-btn color="primary" x-small v-else disabled>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            color="orange"
            x-small
            dark
            @click="deleteItem(item)"
            v-if="
              roles.delete_order &&
              item.current_status == 'Pending' &&
              !item.amazon_info
            "
          >
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
          <v-btn color="orange" x-small v-else disabled>
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense class="menu-scroll">
        <v-list-item>
          <v-select
            :items="listSearchAll"
            :item-text="(obj) => obj.value"
            :item-value="(obj) => obj.id"
            label="Search All"
            dense
            outlined
            v-model="searchBy"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-text-field
            label="Search here"
            outlined
            v-model="searchWord"
            @keyup.enter="search"
            v-if="searchBy != ''"
            dense
          ></v-text-field>
          <v-text-field
            label="Search here"
            outlined
            v-else
            disabled=""
            dense
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listProductType"
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            label="Select Product Type"
            dense
            outlined
            v-model="filterData.productTypeId"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listVendors"
            :item-text="(obj) => obj.vendor_code"
            :item-value="(obj) => obj._id"
            label="Select Vendor"
            dense
            outlined
            v-model="filterData.vendorId"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Order Time"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range scrollable></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-list-item>

        <v-list-item>
          <v-autocomplete
            v-model="sitesSelected"
            :items="listSites"
            :item-text="(obj) => obj.showName"
            :item-value="(obj) => obj.code"
            outlined
            dense
            chips
            small-chips
            label="Select Sites"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
          ></v-autocomplete>
        </v-list-item>

        <v-list-item>
          <v-autocomplete
            v-model="filterData.financialStatuses"
            :items="finStatus"
            outlined
            dense
            chips
            small-chips
            label="Select Financial Status"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
          ></v-autocomplete>
        </v-list-item>

        <v-list-item>
          <v-autocomplete
            v-model="filterData.platform"
            :items="listPlatform"
            outlined
            dense
            label="Select Platform"
          ></v-autocomplete>
        </v-list-item>

        <v-col cols="12">
          <!-- <v-btn @click.stop="drawer = false"  color="warning" fab x-small dark style="float:left">
            <v-icon class="fa fa-arrow-left"></v-icon>
          </v-btn>&nbsp; -->
          <v-btn
            @click="search"
            small
            outlined
            color="indigo"
            style="float: left"
            >Apply</v-btn
          >
          <v-btn
            @click="reset"
            small
            outlined
            color="indigo"
            style="float: right"
            >Reset</v-btn
          >
        </v-col>
      </v-list>
    </v-navigation-drawer>

    <BaseDialog :active.sync="dialogFulfill" dialog_name="Fulfill">
      <ExportOrder
        :selectedItem="selected"
        :username="userId"
        :filterData="filterData"
        :listProductType="listProductType"
        :listVendors="listVendors"
      />
    </BaseDialog>

    <BaseDialog :active.sync="dialogStatus" dialog_name="Change Status">
      <ChangeStatus
        :selectedItem="selected"
        :username="userId"
        :sendStatus="status"
      /><!--  :listStatus="listStatus"/> -->
    </BaseDialog>

    <BaseDialog :active.sync="dialogOrder" dialog_name="Import Order">
      <ImportOrder />
    </BaseDialog>

    <BaseDialog :active.sync="dialogTracking" dialog_name="Import Tracking">
      <ImportTracking />
    </BaseDialog>

    <BaseDialog
      :active.sync="dialogPreProcess"
      dialog_name="Preprocessing Order Data"
    >
      <Preprocessing />
    </BaseDialog>

    <BaseDialog
      :active.sync="dialogCreateAmz"
      dialog_name="Create Amazon Order"
    >
      <CreateAmzOrder />
    </BaseDialog>

    <BaseDialog :active.sync="dialogEditAmz" dialog_name="Edit Amazon Order">
      <EditAmzOrder :orderData="orderSelected" />
    </BaseDialog>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
import ImportOrder from "./c-dialog-order-import";
import ImportTracking from "./c-dialog-tracking-import";
import ExportOrder from "./c-order-export";
import ChangeStatus from "./c-dialog-change-status";
import Preprocessing from "./c-dialog-pre-process-order";
import CreateAmzOrder from "./c-dialog-create-amz-order";
import EditAmzOrder from "./c-dialog-edit-amz-order";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Sites",
  //new Vue({
  components: {
    ImportOrder,
    ImportTracking,
    BaseDialog,
    ExportOrder,
    ChangeStatus,
    Preprocessing,
    CreateAmzOrder,
    EditAmzOrder,
  },

  data: () => ({
    roles: [],
    alertError: false,
    alertSuccess: false,
    dialogFulfill: false,
    dialogStatus: false,
    dialogOrder: false,
    dialogTracking: false,
    dialogPreProcess: false,
    dialogCreateAmz: false,
    dialogEditAmz: false,
    loading: true,
    loadingData: false,
    menu2: false,
    drawer: false,
    group: null,
    listPlatform: ["Shopify", "Amazon"],

    searchBy: "",
    searchWord: "",
    status: "",
    order_from: "",
    order_to: "",
    dates: [],
    textDates: "",
    vendorId: "",
    productTitle: "",
    sitesSelected: [],
    searchInput: null,

    direction: "bottom",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    transition: "slide-y-reverse-transition",

    filterData: {
      searchBy: "",
      searchWord: "",
      dates: [],
      status: "",
      siteCodes: "",
      vendorId: "",
      productTypeId: "",
      financialStatuses: [],
      platform: "",
    },

    processingOrders: 0,
    pendingOrders: 0,
    missingDesignOrders: 0,
    onHoldOrders: 0,
    deliveredOrders: 0,
    inTransitOrders: 0,
    inProductionOrders: 0,
    needResendOrders: 0,
    partiallyRefundedOrders: 0,
    refundedOrders: 0,
    completedOrders: 0,
    canceledOrders: 0,
    totalItems: 0,
    orders: [],
    totalOrders: 0,

    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: false,
      groupDesc: false,
      multiSort: false,
      mustSort: false,
    },

    selected: [],
    userId: "",
    listStatus: [],
    informText: "",
    //showFulfillBtn: false,

    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),

    headers: [
      { text: "#Order", value: "order_number" },
      { text: "Order Time", value: "order_time" },
      { text: "Customer Name", value: "customer_info" },
      { text: "Priority", value: "priority" },
      { text: "Status", value: "current_status" },
      { text: "Item(s)", value: "items" },
      { text: "Total Price", value: "payment_info.total" },
      { text: "Payment", value: "financial_status" },
      { text: "Latest Ship Date (D/M/Y)", value: "latest_ship_date" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    listSearchAll: [
      { id: "order_number", value: "Order Number" },
      { id: "order_id", value: "Order ID" },
      { id: "product_title", value: "Product Title" },
    ],
    listProductType: [],
    listVendors: [],
    listSites: [],
    finStatus: [],

    orderSelected: null,
  }),

  watch: {
    pagination: {
      handler() {
        let queryParams = this.getParams();

        this.$router
          .push({ path: "orders", query: queryParams })
          .catch((err) => {
            var error = err.toString();
            if (!error.includes("redundant navigation")) {
              throw err;
            }
          });
        console.log("pagination");
        this.getDataFromApi();
      },
      deep: true,
    },

    dialogStatus() {
      console.log("dialogStatus");
      this.getDataFromApi();
    },

    dialogFulfill() {
      console.log("dialogFulfill");
      this.getDataFromApi();
    },
  },

  created() {
    this.$root.$refs.order = this;
  },

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },

  methods: {
    turnOffDialog() {
      this.dialogOrder = false;
      this.dialogTracking = false;
      this.dialogPreProcess = false;
      this.dialogFulfill = false;
      this.dialogStatus = false;
      this.dialogCreateAmz = false;
      this.dialogEditAmz = false;

      this.getDataFromApi();
    },

    clearSelected() {
      this.selected = [];
    },

    async exportSelectedOrders() {
      var r = confirm("Are you sure you want to export selected orders?");
      if (r != false) {
        var data = {
          orders: [],
        };
        for (const i of this.selected) {
          var temp = {
            order_number: "",
            order_id: "",
          };
          temp.order_number = i.order_number;
          temp.order_id = i.order_id;
          data.orders.push(temp);
        }

        console.log(JSON.stringify(data));

        var currentSession = await this.$root.$refs.App.currentSession(
          "export-selected-order"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          fetch(window.domain + "orders/export-orders-from-store", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("export-selected-order response: ", data);
              if (data.error_message == "") {
                this.showAlert("export", null);
              } else {
                this.showAlert("exportError", data.error_message);
              }
            })
            .catch((error) => console.log(error));
        } else {
          console.log(
            "currentSession export-selected-order-undefined: ",
            currentSession
          );
        }
      }
    },

    async exportMissingTrack() {
      var r = confirm("Are you sure you want to export orders missing track?");
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "export-missing-track"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          fetch(window.domain + "orders/export-missing-track", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("export-missing-track response: ", data);
              if (data.error_message == "") {
                this.showAlert("export", null);
              } else {
                this.showAlert("exportError", data.error_message);
              }
            })
            .catch((error) => console.log(error));
        } else {
          console.log(
            "currentSession export-missing-track-undefined: ",
            currentSession
          );
        }
      }
    },

    async changeStatus() {
      var list = [];
      this.selected.forEach((element) => {
        list.push(element.product_id);
      });

      var currentSession = await this.$root.$refs.App.currentSession(
        "order-changeStatus"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        fetch(window.domain + "products/change-status", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            new_status: "Missing Info",
            product_ids: list,
          }),
        })
          .then((response) => {
            response.json();
          })
          .then((data) => {
            console.log("changeStatus response: ", data);
            this.getDataFromApi();
          })
          .catch((error) => console.log(error));
      } else {
        console.log(
          "currentSession order-changeStatus-undefined: ",
          currentSession
        );
      }
      list = [];
      this.selected = [];
    },

    showAlert(type, data) {
      this.alert = true;
      if (type == "order") {
        this.alertSuccess = true;
        this.dialogOrder = false;
        this.informText =
          "We're currently importing your orders into database. This could take somes minutes to complete. If you'd like, you can close this notification and continue to working.";
      } else if (type == "tracking") {
        this.alertSuccess = true;
        this.dialogTracking = false;
        this.informText =
          "We're currently importing your tracking number into database. This could take about " +
          Math.ceil(data / 1000) +
          " minutes to complete. If you'd like, you can close this notification and continue to working.";
      } else if (type == "preprocessing-order") {
        this.alertSuccess = true;
        console.log("preprocessing-order: ", data);
        this.dialogPreProcess = false;
        this.informText =
          "We're currently preprocessing your order data. System will send a file to your email when completed. If you'd like, you can close this notification and continue to working.";
      } else if (type == "export") {
        this.alertSuccess = true;
        console.log("export: ", data);
        this.dialogFulfill = false;
        this.informText =
          "We're currently processing your data. System will send a file to your email when completed. If you'd like, you can close this notification and continue to working.";
      } else if (type == "exportError") {
        this.alertError = true;
        this.informText = data;
      } else {
        this.dialogStatus = false;
        this.getDataFromApi();
        this.informText =
          "The following order(s) have been changed status: " + data.join(", ");
        this.selected = [];
      }
      this.getDataFromApi();
    },

    getParams() {
      let queryParams = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy[0],
        sortDesc: this.pagination.sortDesc[0],
      };

      if (this.searchBy != "" && this.searchWord != "") {
        queryParams["searchBy"] = this.searchBy;
        queryParams["searchWord"] = this.searchWord;
      }

      if (this.status != "") {
        queryParams["status"] = this.status;
      }

      if (this.dates.length > 0) {
        if (this.dates[0] > this.dates[1]) {
          queryParams["order_from"] = this.dates[1];
          queryParams["order_to"] = this.dates[0];
        } else {
          queryParams["order_from"] = this.dates[0];
          queryParams["order_to"] = this.dates[1];
        }
      }

      if (this.filterData.productTypeId != "") {
        queryParams["productTypeId"] = this.filterData.productTypeId;
      }

      if (this.filterData.vendorId != "") {
        queryParams["vendorId"] = this.filterData.vendorId;
      }

      if (this.sitesSelected != "") {
        queryParams["siteCodes"] = this.sitesSelected.join(",");
      }

      if (this.filterData.financialStatuses.length > 0) {
        queryParams["financialStatuses"] =
          this.filterData.financialStatuses.join(",");
      }

      if (this.filterData.platform != "") {
        queryParams["platform"] = this.filterData.platform;
      }

      return queryParams;
    },

    async getDataFromApi() {
      this.loading = true;
      let queryParams = this.getParams();

      var currentSession = await this.$root.$refs.App.currentSession(
        "order-loadData"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "orders?", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log(response);
            this.orders = response.data.data.orders;
            this.listVendors = response.data.data.vendors;
            this.listProductType = response.data.data.productTypes;
            this.listSites = response.data.data.sites;
            this.totalOrders = response.data.data.totalOrders || "0";
            this.processingOrders = response.data.data.processingOrders || "0";
            this.pendingOrders = response.data.data.pendingOrders || "0";
            this.missingDesignOrders =
              response.data.data.missingDesignOrders || "0";
            this.onHoldOrders = response.data.data.onHoldOrders || "0";
            this.deliveredOrders = response.data.data.deliveredOrders || "0";
            this.inTransitOrders = response.data.data.inTransitOrders || "0";
            this.inProductionOrders =
              response.data.data.inProductionOrders || "0";
            this.needResendOrders = response.data.data.needResendOrders || "0";
            this.refundedOrders = response.data.data.refundedOrders || "0";
            this.partiallyRefundedOrders =
              response.data.data.partiallyRefundedOrders || "0";
            this.completedOrders = response.data.data.completedOrders || "0";
            this.canceledOrders = response.data.data.canceledOrders || "0";
            this.totalItems = response.data.data.marchingOrders;
            this.listStatus = response.data.data.statuses;
            this.finStatus = response.data.data.financialStatuses;

            var today = new Date(); //moment(new Date()).tz("America/Los_Angeles");

            for (var site of this.listSites) {
              if (site.brand_name)
                site["showName"] = site.code + " - " + site.brand_name;
              else site["showName"] = site.code;
            }
            console.log("this.listSites: ", this.listSites);

            for (const i of this.orders) {
              for (const u of i.items) {
                if (u.sku == "") {
                  i["missingSKU"] = true;
                  break;
                } else {
                  i["missingSKU"] = false;
                }
              }

              i["createdFromNow"] = moment(i.order_time).fromNow();
              i.order_time = moment(i.order_time)
                .tz("America/Los_Angeles")
                .format("DD/MMM/YYYY - HH:mm:ss");

              for (const j of i.order_statuses) {
                j.updated_date = moment(j.updated_date)
                  .tz("America/Los_Angeles")
                  .format("DD/MMM/YYYY - HH:mm:ss");
              }
              i["urgent"] = false;

              if (i.amazon_info) {
                if (
                  i.amazon_info.latest_ship_date != "1970-01-01T00:00:00.000Z"
                ) {
                  i["lastestShipFromNow"] = moment(
                    i.amazon_info.latest_ship_date
                  ).fromNow();

                  i.amazon_info.latest_ship_date = moment(
                    i.amazon_info.latest_ship_date
                  )
                    .tz("America/Los_Angeles")
                    .format("DD/MMM/YYYY - HH:mm:ss");
                } else {
                  i["lastestShipFromNow"] = "";
                  i.amazon_info.latest_ship_date = "";
                }

                var a =
                  (new Date(i.amazon_info.latest_ship_date) - today) /
                  (1000 * 3600);
                // console.log("DateDiff: ", a);

                if (i.tracking_numbers == 0 && a < 48) {
                  i["urgent"] = true;
                }
              }
            }
            //console.log(this.orders)
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error:", error);
            this.loading = false;
            this.orders = [];
          });
      } else {
        console.log(
          "currentSession order-loadData-undefined: ",
          currentSession
        );
      }
    },

    search() {
      let queryParams = this.getParams();
      queryParams.page = 1;
      this.pagination.page = 1;
      //this.selected = []

      (this.filterData.searchBy = this.searchBy),
        (this.filterData.searchWord = this.searchWord),
        (this.filterData.dates = this.dates),
        (this.filterData.status = this.status),
        (this.filterData.siteCodes = this.sitesSelected.join(","));

      console.log(queryParams);
      this.$router.push({ path: "orders", query: queryParams }).catch((err) => {
        var str = err.toString();
        if (str.includes("current location")) {
          err = "";
        }
      });

      console.log("search");
      this.getDataFromApi();
    },

    reset() {
      //this.$router.push({ path: "orders" });
      //this.orders = [];
      this.searchWord = "";
      this.searchBy = "";
      this.status = "";
      this.order_from = "";
      this.order_to = "";
      this.dates = [];
      //this.selected = []
      // this.pagination = {
      //   page: 1,
      //   itemsPerPage: 10,
      //   sortBy: [],
      //   sortDesc: [],
      //   groupBy: false,
      //   groupDesc: false,
      //   multiSort: false,
      //   mustSort: false,
      // },
      (this.filterData = {
        searchBy: "",
        searchWord: "",
        dates: [],
        status: "",
        siteCodes: "",
        vendorId: "",
        productTypeId: "",
        financialStatuses: [],
        platform: "",
      }),
        (this.sitesSelected = []);
      console.log("reset");
      //this.getDataFromApi()
    },

    editItem(item) {
      const params = window.location.search;
      this.$router.push("/order-edit/" + item + params);
    },

    async deleteItem(item) {
      const index = this.orders.indexOf(item);
      var r =
        confirm("Are you sure you want to delete this item?") &&
        this.orders.splice(index, 1);
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "order-deleteItem"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          await axios.delete(window.domain + "orders/" + item.order_id, {
            headers: { Authorization: currentSession.accessToken },
          });
        } else {
          console.log(
            "currentSession orders-deleteItem-undefined: ",
            currentSession
          );
        }
      }
    },

    async exportPendingOrders() {
      var searchByName = "";
      for (const i of this.listSearchAll) {
        if (i.id == this.searchBy) {
          searchByName = i.value;
          break;
        }
      }
      var vendorName = "";
      for (const i of this.listVendors) {
        if (i._id == this.filterData.vendorId) {
          vendorName = i.vendor_code;
          break;
        }
      }
      var productTypeName = "";
      for (const i of this.listProductType) {
        if (i._id == this.filterData.productTypeId) {
          productTypeName = i.product_type;
          break;
        }
      }

      var r = confirm(
        "Are you sure you want to export this item with follow filter:" +
          "\nSearch By: " +
          searchByName +
          "\nSearch Word: " +
          this.searchWord +
          "\nOrder Time: " +
          this.dates.join("~") +
          "\nProduct Type: " +
          productTypeName +
          "\nVendor: " +
          vendorName +
          "\nSite: " +
          this.sitesSelected.join(", ") +
          "\nFinancial Statuses: " +
          this.filterData.financialStatuses.join(", ") +
          "\nPlatform: " +
          this.filterData.platform
      );

      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "order-exportPendingOrders"
        );
        //console.log('currentSession: ',currentSession.accessToken)

        var filters = {};

        if (this.searchBy != "" && this.searchWord != "") {
          filters["search_by"] = this.searchBy;
          filters["search_word"] = this.searchWord;
        }

        if (this.filterData.productTypeId != "") {
          filters["productTypeId"] = this.filterData.productTypeId;
        }

        if (this.filterData.vendorId != "") {
          filters["vendorId"] = this.filterData.vendorId;
        }

        if (this.sitesSelected.length > 0) {
          filters["siteCodes"] = this.sitesSelected.join(",");
        }

        if (this.dates.length > 0) {
          if (this.dates[0] > this.dates[1]) {
            filters["order_from"] = this.dates[1];
            filters["order_to"] = this.dates[0];
          } else {
            filters["order_from"] = this.dates[0];
            filters["order_to"] = this.dates[1];
          }
        }

        if (this.filterData.financialStatuses.length > 0) {
          filters["financialStatuses"] =
            this.filterData.financialStatuses.join(",");
        }

        if (this.filterData.platform != "") {
          filters["platform"] = this.filterData.platform;
        }

        console.log(filters);

        if (currentSession.accessToken) {
          await fetch(window.domain + "orders/export-pending-orders", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify({
              filters,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("export-pendingData: ", data);
              console.log("data.message: ", data.message);
              //var error = data.error_message.toString()
              if (data.error_message == "") {
                this.showAlert("export", null);
              } else if (data.message == "Service Unavailable") {
                this.showAlert("export", null);
              } else {
                this.loading = false;
                this.showAlert("exportError", data.error_message);
                return;
              }
            })
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession order-exportPendingOrders-undefined: ",
            currentSession
          );
        }
      }
    },

    check() {
      console.log(this.orders);
      console.log(this.menu2);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async beforeMount() {
    //console.log(this.AuthStr)
    if (this.$route.query != "") {
      console.log("this.$route.query OK");
      if (this.$route.query.page)
        this.pagination.page = parseInt(this.$route.query.page);
      if (this.$route.query.itemsPerPage)
        this.pagination.itemsPerPage = parseInt(this.$route.query.itemsPerPage);
      if (this.$route.query.sortBy)
        this.pagination.sortBy[0] = this.$route.query.sortBy;
      if (this.$route.query.sortDesc)
        this.pagination.sortDesc[0] = this.$route.query.sortDesc;

      if (this.$route.query.searchBy) {
        this.searchBy = this.$route.query.searchBy;
        this.filterData.searchBy = this.$route.query.searchBy;
      }

      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
        this.filterData.searchWord = this.$route.query.searchWord;
      }

      if (this.$route.query.status) {
        console.log("this.$route.query.status: ", this.$route.query.status);
        this.status = this.$route.query.status;
        console.log("status: ", this.status);
        this.filterData.status = this.$route.query.status;
      }

      if (this.$route.query.order_from) {
        this.order_from = this.$route.query.order_from;
        this.dates.push(this.order_from);
      }
      if (this.$route.query.order_to) {
        this.order_to = this.$route.query.order_to;
        this.dates.push(this.order_to);
      }
      this.filterData.dates = this.dates;

      if (this.$route.query.productTypeId)
        this.filterData.productTypeId = this.$route.query.productTypeId;

      if (this.$route.query.vendorId)
        this.filterData.vendorId = this.$route.query.vendorId;

      if (this.$route.query.siteCodes) {
        this.filterData.siteCodes = this.$route.query.siteCodes;
        this.sitesSelected = this.filterData.siteCodes.split(",");
      }

      if (this.$route.query.financialStatuses) {
        var temp = this.$route.query.financialStatuses;
        this.filterData.financialStatuses = temp.split(",");
      }

      if (this.$route.query.platform) {
        this.filterData.platform = this.$route.query.platform;
      }
    }

    console.log("beforeMount");
    this.roles = await this.$cookies.get("order");
    if (this.roles.list_orders) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var currentSession;
    try {
      currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
      console.log("order-mounted currentSession: ", currentSession);
    } catch (error) {
      console.log("order-mounted error: ", error);
    }

    if (currentSession != undefined) {
      this.userId = currentSession.accessToken.payload.username;
    }
  },
};
</script>

<style scoped>
.status-scroll {
  height: 40vh;
  overflow: auto;
}

.menu-scroll {
  height: 90vh;
  overflow: auto;
}
</style>